<template>
  <b-container fluid class="bg-white px-4 py-3 custom-font-size">
    <!-- Week Switcher Section -->
    <div class="row align-items-center py-2 mb-4 switcher-container">
      <div class="col-3 text-left pl-3">
        <b-button
          variant="outline-primary"
          size="sm"
          class="btn-switcher px-3 py-2"
          @click="prevWeek()"
          v-if="!loading">
          <b-icon icon="chevron-left" class="mr-2"></b-icon>
          Previous Week
        </b-button>
      </div>
      <div class="col-6 text-center">
        <div class="month-display d-flex align-items-center justify-content-center" @click="currentWeek()" v-if="!loading" style="cursor: pointer;" title="Click to fetch last updates">
          <b-icon icon="calendar3" class="mr-2 text-primary" font-scale="1.1"></b-icon>
          <span class="month-title">{{ monthInfo }}</span>
        </div>
        <div class="month-display text-muted" v-else>
          <b-spinner small class="mr-2" type="grow"></b-spinner>
          Loading, Please wait...
        </div>
      </div>
      <div class="col-3 text-right pr-3">
        <b-button
          variant="outline-primary"
          size="sm"
          class="btn-switcher px-3 py-2"
          @click="nextWeek()"
          v-if="!loading">
          Next Week
          <b-icon icon="chevron-right" class="ml-2"></b-icon>
        </b-button>
      </div>
    </div>

    <!-- Calendar Table Section -->
    <div class="row lizard-calendar">
      <div class="col-12 lizard-calendar-holder">
        <StaffingCalendar
          :loading="loading"
          :fields="calendarFields"
          :list="calendarData" />
      </div>
    </div>
  </b-container>
</template>

<script>
import {
  format as dateFormat,
  sub,
  add,
  differenceInDays
} from 'date-fns'
import ServicesOld from '../../services/index.vue'
import StaffingCalendar from './Staffing/Calendar.vue'

export default {
  name: 'StaffingLogs',
  components: {
    StaffingCalendar
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    calendarWeeksStartDate() {
      return this.Store.staffingCalendarWeeksStartDate
    }
  },
  data() {
    return {
      loading: false,
      showWeekends: true,
      dataFetched: false,
      monthInfo: dateFormat(new Date(), 'MMMM yyyy'),
      usecache: 'y',
      users: [],
      projects: [],
      calendarFields: [],
      calendarData: [],
      updateTimeout: null
    }
  },
  mounted() {
    this.tabMounted()
  },
  methods: {
    tabMounted() {
      this.setDefaultCalendarWeeksStartDate()
      this.currentWeek()
    },
    commitToStore(commitName, value) {
      this.$store.commit(commitName, value)
    },
    prevWeek() {
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      this.commitToStore(
        'setStaffingCalendarWeeksStartDate',
        sub(new Date(this.calendarWeeksStartDate), {
          weeks: 1
        })
      )
      this.setCurrentMonth()
    },
    nextWeek() {
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      this.commitToStore(
        'setStaffingCalendarWeeksStartDate',
        add(new Date(this.calendarWeeksStartDate), {
          weeks: 1
        })
      )
      this.setCurrentMonth()
    },
    currentWeek() {
      this.setCurrentMonth()
    },
    setDefaultCalendarWeeksStartDate(setNull = false) {
      if (setNull) {
        this.commitToStore('setStaffingCalendarWeeksStartDate', null)
      } else {
        this.commitToStore('setStaffingCalendarWeeksStartDate')
      }
    },
    setCurrentMonth() {
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      const now = new Date()
      const startDate = this.calendarWeeksStartDate
      const isCurrentWeek = this.isWithinTwoWeeks(now, startDate)

      const monthsDays = this.countDaysByMonth(startDate)
      const selectedMonth = this.getFirstMonthWithMinDays(monthsDays, 7)
      const selectedYear = isCurrentWeek
        ? this.getYear(now)
        : this.getYear(startDate)
      this.monthInfo = selectedMonth + ' ' + selectedYear
    },
    isWithinTwoWeeks(date1, date2) {
      const diffInDays = differenceInDays(add(date2, { days: 13 }), date1)
      return diffInDays > 0 && diffInDays < 14
    },
    countDaysByMonth(startDate) {
      const monthsDays = {}
      const start = new Date(startDate)
      const end = add(new Date(startDate), { days: 13 })

      const loopDate = new Date(start)
      while (loopDate <= end) {
        const month = this.getMonthName(loopDate)
        monthsDays[month] = (monthsDays[month] || 0) + 1
        loopDate.setDate(loopDate.getDate() + 1)
      }

      return monthsDays
    },
    getFirstMonthWithMinDays(monthsDays, minDays) {
      for (const month in monthsDays) {
        if (monthsDays[month] >= minDays) {
          return month
        }
      }
      return null
    },
    getMonthName(date) {
      try {
        return dateFormat(date, 'MMMM')
      } catch (error) {
        console.error({ error })
        return null
      }
    },
    getYear(date) {
      try {
        return dateFormat(date, 'yyyy')
      } catch (error) {
        console.error({ error })
        return null
      }
    },
    createCSSClass(className, rules) {
      const style = document.createElement('style')
      const cssRule = `.${className} { ${rules} }`
      if (style.styleSheet) {
        style.styleSheet.cssText = cssRule
      } else {
        style.appendChild(document.createTextNode(cssRule))
      }
      document.head.appendChild(style)
    },
    addStyles(list = []) {
      return list.map((itm) => {
        // itm._rowVariant = 'light'
        itm._cellVariants = {
          name: 'primary'
        }
        return itm
      })
      // return list
    },
    async fetchCalendarData() {
      this.loading = true
      const { status, data } = await ServicesOld.GetStaffingCalendar({
        fromDate: dateFormat(this.calendarWeeksStartDate, 'yyyy-MM-dd')
      })
      if (status !== 200) {
        this.loading = false
        return
      }
      const { fields, list } = data.content
      if (fields && fields.length > 0) {
        fields[0].label = 'Calendar'
      }
      this.calendarFields = fields
      this.calendarData = this.addStyles(list)
      this.loading = false
    }
  },
  watch: {
    calendarWeeksStartDate() {
      setTimeout(() => {
        this.dataFetched = false
        this.fetchCalendarData()
      }, 500)
    }
  }
}
</script>

<style scoped>
.switcher-container {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}
.btn-switcher {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 150px;
  transition: all 0.2s ease !important;
}
.month-display {
  padding: 5px;
}
.month-title {
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  color: #0073be !important;
  letter-spacing: -0.01em;
}
</style>

<style>
.custom-font-size {
  font-size: 10px !important;
}
</style>
